import store from '../store'
import { savePoint } from '@/api/tao.js'
export function setPoint(payLoad) {
    let pointArr = JSON.parse(localStorage.getItem('ma-point-list') || '[]')
    // let payLoad = {
    //     firDir: to.matched[0].meta.title,
    //     thirDir: to.matched[0].meta.title,
    //     secDir: to.matched[0].meta.title,
    //     function: '进入页面',
    //     operationDatail: ''
    // }
    let obj = {
        userId: localStorage.getItem('ma-userId') || '',
        userName: localStorage.getItem('ma-name') || '',
        shopName: localStorage.getItem('ma-shopName') || ''
    }
    if (store.getters.isFromPlugin) {
        obj.firDir = '插件' 
        // savePoint([{...payLoad, ...obj}])
        // return
    }
    pointArr.push({...payLoad, ...obj,})
    localStorage.setItem('ma-point-list', JSON.stringify(pointArr))
}


// WEBPACK FOOTER //
// ./src/utils/setPoint.js